import { render, staticRenderFns } from "./ConcernDeleteModal.vue?vue&type=template&id=c4bba512&scoped=true&"
import script from "./ConcernDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConcernDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bba512",
  null
  
)

export default component.exports